import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { chatActions } from "_actions";
import { AppearFromBottom, QuicklinkButton } from "global/style";
import BackQuickLink from "./Components/BackQuickLink";
import NextQuickLink from "./Components/NextQuickLink";
import PreviousQuickLink from "./Components/PreviousQuickLink";
import CustomOrAnyQuickLink from "./Components/CustomOrAnyQuickLink";
import TextQuickLink from "./Components/TextQuickLink";
import QuicklinkButtonImage from "./Components/QuicklinkButton.Image";
import styled from "styled-components";


const quickLinkSubTypes = {
  "customOrAny": CustomOrAnyQuickLink,
  "nav-next": NextQuickLink,
  "nav-prev": PreviousQuickLink,
  "back": BackQuickLink,
  "next": NextQuickLink,
  "text": TextQuickLink
}

function TextQuickLinks({ data, send, specials, selectQuicklinks, selectedQuicklinks, clearSelectedQuicklinks }) {

  const [subType, setSubType] = useState(null);
  const [quicklinkStyle, setQuicklinkStyle] = useState({
    bgColor: "#fff",
    txtColor: "#0f0538",
    hoverColor: "#0f0538",
    hoverBgColor: "#0f0538",
    borderColor: "#0f0538",
    bgColorNext: "#0f0538",
    hoverBgColorNext: "#0f0538",
    txtColorNext: "#fff",
    hoverColorNext: "#fff",
    borderColorNext: "#fff",
  });
  const [isSelected, setIsSelected] = useState(false);

  const handleClick = (dispatch) => {
    if (data.value === 'Rentgrata-TalkToResidentConversation') {
      window.parent.postMessage('open-rentgrata', '*');
    }

    if (data.is_multiselect) {
      setQuicklinkStyle({
        ...quicklinkStyle,
        bgColor: isSelected ? "#fff" : "#0f0538",
        txtColor: isSelected ? "#0f0538" : "#fff"
      })
      setIsSelected(!isSelected)
      selectQuicklinks(data.text)

      if (data.value == 'next') {
        data = selectedQuicklinks.join(',').replace('Next', '')
        if (data === '') {
          data = 'none'
        }
        clearSelectedQuicklinks()
        send(data, "text");
      }
    } else {
      send(data, "text");
    }
  };

  const handleClickQuicklink = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      handleClick();
    }
  };

  useEffect(() => {
    let type = "text";

    if (data.subType) {
      if (data.subType === "any" || data.subType === "custom") {
        type = "customOrAny";
      } else {
        type = data.subType
      }
    }
    if (data.value == 'next') {
      setQuicklinkStyle({
        ...quicklinkStyle,
        bgColorNext: "#F0F0F0",
        hoverColorNext: "#FFFFFF",
        txtColorNext: "#0f0538",
        hoverBgColorNext: "#42ACCD",
        borderColorNext: "#F0F0F0",
      })
    }

    setSubType(type);
  }, [data.subType]);

  const QuickLink = useMemo(() => quickLinkSubTypes[subType], [subType]);

  if (!subType) {
    return <></>
  }

  const textLength = data & data.text.length;

  if (data.text.includes('$') && data.value.includes('price')) {
    data.text = data.text.replace(/\$\s/g, '$');
  }

  const chatWithAResidentImage = typeof (data.image) !== 'undefined' ? data.image : null;

  return (
    <AppearFromBottom className="TextAppearFromBottom">
      <QuicklinkButton
        className="QuicklinkButton"
        onClick={handleClick}
        tabIndex={0}
        role="button"
        onKeyPress={(e) => handleClickQuicklink(e)}
      >
        {
          chatWithAResidentImage
            ? <QuicklinkButtonImage text={data.text} image={chatWithAResidentImage}></QuicklinkButtonImage>
            : <QuickLink text={data.text} specials={specials} textLength={textLength} quicklinkStyle={quicklinkStyle} />
        }
      </QuicklinkButton>
    </AppearFromBottom>
  );
}

const mapStateToProps = (state) => ({
  quicklinkStyle: state.quicklinkStyle,
  isSelected: state.isSelected,
  selectedQuicklinks: state.chat.selectedQuicklinks
});

const actions = {
  send: chatActions.send,
  selectQuicklinks: chatActions.selectQuicklinks,
  clearSelectedQuicklinks: chatActions.clearSelectedQuicklinks,
};

export default connect(mapStateToProps, actions)(TextQuickLinks);
